// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3hA6z","selected":"Chip_selected__3vpe_"};